

/*
	Source: htdocs/wim/js/core/src/Favorite.js
*/
(function($, wimbledonCore) {
var Favorite = function() {
        var id = 'Favorite';
        // eventsCore.setLogLevel('all');
        var logger = new eventsCore.util.Logger(id);
        var storePlayers = eventsCore.StoragePlayers();
        var api = {};

        var init = false;
        var players = [];
        var cookie_expires = 365; // new Date("April 7, 2014");
        var maxFavorites = 10;
        var regex = /overview\/([a-z0-9]*)\.html/;
        var elem = 'span.favorite';

        api.event = $('<div>');

        storePlayers.on('added', function(pid) {
            api.event.trigger('added', pid);
        });
        storePlayers.on('removed', function(pid) {
            api.event.trigger('removed', pid);
        });

        var onAdded = function() {
            players = storePlayers.get();
            logger.info('onAdded - list:%o', players);
            updateStars();
        };

        var onRemoved = function() {
            players = storePlayers.get();
            logger.info('onRemoved - list:%o', players);
            updateStars();
        };

        var updateStars = function() {
            var $elem = $(elem);
            $elem.filter('.selected').removeClass('selected');

            for (var i = 0; i < players.length; i++) {
                var player = $elem.filter('[data-id="' + players[i] + '"]');
                player.addClass("selected");
                //logger.info('updateStars - id:%o elem:%o', players[i], elem);
                if (player.length === 0) {
                    player = $('a[href = "overview/' + players[i] + '.html"]');
                    //logger.info('updateStars - %o', elem);
                    player.siblings(elem).addClass("selected");
                }
            }
        };

        api.get = function() {
            return players = storePlayers.get();
        }

        /**
         init function
         @selector - defines slecetor for elements to listen for clicks
        */
        api.init = function(selector) {
            if(selector !== undefined) {
                elem = selector;
            }
            players = storePlayers.get();
            logger.info('init - selector:%o store:%o players:%o', selector, storePlayers, players);

            api.event.on('added', onAdded);
            api.event.on('removed', onRemoved);

            $(document).ready(function(){
                updateStars();
            });

            $(document).on('click', elem, function(e) {
                e.preventDefault();
                var $this = $(this);
                //logger.info('player click - %o', $(this).attr('data-id'));
                var id = $this.attr('data-id');

                if (id === '') {
                    //$this.next('a');
                    var href = $this.siblings('a').attr('href');
                    var search = href.match(regex);
                    //logger.info('player click - href:%o search:%o', href, search);
                    if(search !== null) {
                        id = search[1];
                    }
                }

                if (id !== '' && (players.length < maxFavorites || $this.hasClass('selected'))) {
                    storePlayers.toggle(id);
                }
                else {
                    alert("You may only save a maximum of " + maxFavorites + " players.")
                }
            });
        };

        return api;
    };

    wimbledonCore.favorite = new Favorite();

}(jQuery, window.wimbledonCore));